import BaseService from "./BaseService";

export default class RetornoBancarioService extends BaseService {

  constructor(self) {
    super(self);
  }

    BuscarRetornoBancario(nossoNumero) {
        return this.ExecutaFetch("/api/RetornoBancario/" + nossoNumero, "GET");
  }

}